import React, { useEffect, useState } from "react";
import TopMenuItemLink from "./topNavigation/TopMenuItemLink";
import { useParams } from "react-router-dom";
import useUrlQueryParams from "src/hooks/useUrlQueryParams";
import { Menu } from "@headlessui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import { classNames } from "src/helpers/classNames";

const HeaderMenus = ({ menus, setOverflowedHeaderMenus }) => {
  const { menu_id } = useParams();
  const { group: group_id } = useUrlQueryParams();

  const [maxVisible, setMaxVisible] = useState(5);

  const visibleMenus = menus.slice(0, maxVisible);
  const overflowMenus = menus.slice(maxVisible);

  const calculateMaxVisible = () => {
    const width = window.innerWidth;
    if (width < 700) return 0;
    if (width < 700) return 1;
    if (width < 800) return 2;
    if (width < 1100) return 2;
    if (width < 1300) return 3;
    if (width < 1400) return 4;
    if (width < 1500) return 5;
    if (width > 1500) return 6;

    return 6;
  };

  useEffect(() => {
    const handleResize = () => {
      setMaxVisible(calculateMaxVisible());
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (overflowMenus.length > 0 && window.innerWidth < 700) {
      setOverflowedHeaderMenus(overflowMenus);
    } else {
      setOverflowedHeaderMenus([]);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.innerWidth, overflowMenus.length]);

  if (!menus || menus.length === 0) return null;

  const isMenuItemActive = (item) => {
    if (item.sub) {
      return (item._id === menu_id || item.slug === menu_id) && item.groupId === group_id;
    }
    if (item?.headerMenu) {
      return item._id === menu_id || item.slug === menu_id;
    }
    return ((item._id === menu_id || item.slug === menu_id) && !item.groupId && !group_id) || (item.groupId && group_id && item.groupId === group_id && (item._id === menu_id || item.slug === menu_id));
  };

  return (
    <div className="animate-fade-in flex items-center  space-x-2 px-3 ">
      {visibleMenus.map((item) => (
        <TopMenuItemLink
          key={item._id}
          data={item}
          group_id={group_id}
          image={item?.image}
          menu_id={menu_id}
        />
      ))}

      {overflowMenus.length > 0 && window.innerWidth > 700 && (
        <Menu
          as="div"
          className="relative">
          {({ open }) => (
            <>
              <Menu.Button
                className={classNames(
                  "flex items-center gap-1 rounded-md px-3 py-1  font-medium",
                  "hover:bg-headerMenuActiveBgColor hover:text-headerMenuActiveTextColor",
                  overflowMenus?.some(isMenuItemActive) ? "bg-headerMenuActiveBgColor text-headerMenuActiveTextColor" : "text-headerTextColor",
                )}>
                {window.innerWidth < 700 ? "Menus" : "More"}
                {open ? <ChevronUpIcon className="h-5 w-5" /> : <ChevronDownIcon className="h-5 w-5" />}
              </Menu.Button>

              <Menu.Items className="absolute right-0 z-20 mt-4 w-56 origin-top-right rounded-md bg-headerColor shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="p-1">
                  {overflowMenus.map((item) => (
                    <Menu.Item
                      key={item._id}
                      className="rounded-md p-1">
                      <div>
                        <TopMenuItemLink
                          data={item}
                          group_id={group_id}
                          image={item?.image}
                          menu_id={menu_id}
                        />
                      </div>
                    </Menu.Item>
                  ))}
                </div>
              </Menu.Items>
            </>
          )}
        </Menu>
      )}
    </div>
  );
};

export default HeaderMenus;
